import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row, Spin } from 'antd';
import { History } from 'history';

import { Navbar } from '../layout/Header';
import { EmptyContainer } from '../layout/EmptyContainer';
import { MealList } from './components/MealList';

import { getUserState } from '../../store/user/selector';
import { getMyMeals } from '../../store/meals/actions';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { getMealState } from '../../store/meals/selector';

import EmptyMealIcon from '../../assets/images/png/fork.png';
import i18next from 'i18next';

export const MyMeals: React.FC = () => {
  const history: History = useHistory();
  const { isLoading } = useSelector(getAppGlobalState);
  const { user } = useSelector(getUserState);
  const { meals } = useSelector(getMealState);
  const { accountType } = user;
  const isCook = accountType === 'cook';

  const dispatch = useDispatch();

  const handButtonClick = () => {
    history.push('/mymeals/create');
  };

  const validate = () => {
    if (!isCook && user.userid) {
      history.push('/profile');
      return;
    }
    dispatch(getMyMeals());
  };

  useEffect(validate, [dispatch, isCook, history]);
  return (
    <div className="my-meals-container">
      <Row justify="center">
        <Navbar />
      </Row>
      {!isLoading ? (
        <React.Fragment>
          {meals.length ? (
            <MealList />
          ) : (
            <EmptyContainer
              title={i18next.t('NO_OFFER_LISTED')}
              icon={EmptyMealIcon}
              onClick={handButtonClick}
            />
          )}
        </React.Fragment>
      ) : (
        <Row justify="center" className="spinner-container">
          <Spin />
        </Row>
      )}
    </div>
  );
};
